module.exports = __webpack_public_path__ + "img/grey.0329f489.png";